export const showStart = (starts) => {
  if (starts != null && moment().isBefore(starts)) {
    return starts
  }
  return false
}

export const isLate = (due) => {
  return moment().isAfter(due)
}

export const isStarted = (start) => {
  return moment().isAfter(start)
}

export const isSoon = (date, soonThresholdHours) => {
  if (soonThresholdHours == null) {
    soonThresholdHours = 12
  }
  return Math.abs(moment().diff(date, "hours")) < soonThresholdHours
}

export const getLabel = (date, isStart) => {
  let label = this.getShortLabel(date)
  if (!isStart) {
    if (this.isLate(date)) {
      label = "late"
    } else if (this.isSoon(date)) {
      label = "due"
    }
  }
  return label
}

export const getShortLabel = (date) => {
  date = moment(date)
  const days = Math.abs(moment().diff(date, "days"))
  let label = date.format("MMM. D")
  if (days < 7) {
    label = date.format("ddd")
  }
  return label
}

export const getTitle = (date, isStart) => {
  if (isStart == null) {
    isStart = false
  }
  const dateFormatted = moment(date).format("MMM Do @ hh:mma")
  if (isStart) {
    return `starts ${dateFormatted}`
  } else {
    return `due ${dateFormatted}`
  }
}

export const getDatesClassName = (due, starts) => {
  let className = "StepDate__label"
  const isStart = this.showStart(starts)
  const date = isStart || due
  if (!isStart) {
    if (this.isLate(due)) {
      className = `${className} StepDate__label-late`
    } else if (this.isSoon(date)) {
      className = `${className} StepDate__label-soon`
    }
  }
  return className
}

export const getDatesLabel = (due, starts) => {
  if (starts == null) {
    starts = null
  }
  const isStart = this.showStart(starts) !== false
  const date = this.showStart(starts) || due
  return this.getLabel(date, isStart)
}

export const getDatesTitle = (due, starts) => {
  if (starts == null) {
    starts = null
  }
  const isStart = this.showStart(starts) !== false
  const date = isStart || due
  return this.getTitle(date, isStart)
}

export const shouldShowDatesForStep = (step) => {
  if (step.progress >= 1.0) {
    return false
  }

  let { due, starts } = step
  starts = this.showStart(starts)
  if (!due && !starts) {
    return false
  } else {
    return true
  }
}

export const getEstimatedTimeDisplay = (seconds, t) => {
  let days
  let minutes = null
  let hours = null
  if (seconds >= 60) {
    hours
    minutes = Math.floor(seconds / 60)
    seconds = seconds % 60
  }
  if (minutes >= 60) {
    hours = Math.floor(minutes / 60)
    minutes = minutes % 60
  }
  // if (hours >= 24) {
  //   days = Math.floor(hours / 24)
  //   hours = hours % 24
  // }

  const display = []
  if (seconds > 0) {
    display.unshift(t(`{{ seconds }}s`, { seconds }))
  }
  if (minutes > 0) {
    display.unshift(t(`{{ minutes }}m`, { minutes }))
  }
  if (hours > 0) {
    display.unshift(
      t(`{{ hours }}h`, {
        hours
      })
    )
  }
  if (days > 0) {
    display.unshift(
      t(`{{ days }}d`, {
        days
      })
    )
  }
  return display.filter((s) => s).join(" ")
}
